import { render } from "./botomLeftAlign.vue?vue&type=template&id=6df8ff80"
import script from "./botomLeftAlign.vue?vue&type=script&lang=js"
export * from "./botomLeftAlign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__